import { createFileRoute } from '@tanstack/react-router';

import AccessDenied from '~/features/auth/routes/AccessDenied';

export const Route = createFileRoute('/_auth/accessdenied')({
    component: () => <AccessDenied />,
});
